import { FC, PropsWithChildren } from 'react';

import { Surface } from '@cfa/react-core';

import { cn } from '@/utils/tailwind';

interface FilterSurfaceProps {
  className?: string;
  dataTestId?: string;
}

const FilterSurface: FC<PropsWithChildren<FilterSurfaceProps>> = ({
  children,
  className,
  dataTestId,
}) => (
  <Surface
    data-testid={dataTestId}
    elevation={1}
    radius="sm"
    className={cn('card-styles', className)}
  >
    {children}
  </Surface>
);

export default FilterSurface;
